import { formatCLP, computeIvaBreakdown, computeOriginalPrice } from "../../../../helpers/functions";
import { ButtonLoading } from "../../../../components/buttons/button-loading";

const InvoiceSummary = ({
  plan,
  baseUnitPrice,
  termsAccepted,
  onTermsChange,
  onOpenTerms,
  onConfirm,
  loading,
  disableConfirm = false,
  // Slot opcional para insertar contenido (p. ej. el captcha del checkout
  // público) justo antes del botón de compra. El checkout privado no lo usa.
  captchaSlot = null,
}) => {
  const { subtotal, iva, total } = computeIvaBreakdown(plan.totalPrice);
  const originalPrice = computeOriginalPrice(plan, baseUnitPrice);
  const showDiscount = plan.discountPercentage > 0 && originalPrice > plan.totalPrice;

  return (
    <div className="gm-checkout-invoice">
      <div className="gm-checkout-invoice-title">Resumen de compra</div>

      <div className="gm-checkout-row gm-checkout-product-row">
        <span>
          {plan.testsQuantity} {plan.testsQuantity === 1 ? "test" : "tests"} en {plan.name}
        </span>
        <span>{formatCLP(showDiscount ? originalPrice : plan.totalPrice)}</span>
      </div>
      {showDiscount && (
        <div className="gm-checkout-discount-row">
          <span className="gm-checkout-discount-badge">
            {plan.discountPercentage}% descuento
          </span>
          <span className="gm-checkout-discount-amount">- {formatCLP(originalPrice - plan.totalPrice)}</span>
        </div>
      )}

      <div className="gm-checkout-divider" />

      <div className="gm-checkout-row">
        <span>Subtotal (neto)</span>
        <span>{formatCLP(subtotal)}</span>
      </div>
      <div className="gm-checkout-row">
        <span>IVA (19%)</span>
        <span>{formatCLP(iva)}</span>
      </div>

      <div className="gm-checkout-total-line">
        <span>Total</span>
        <span>{formatCLP(total)}</span>
      </div>

      <p className="gm-checkout-disclaimer">
        Este es un servicio digital de acceso inmediato. No se realizan
        devoluciones una vez iniciado el test.
      </p>

      <label className="gm-checkout-terms-label">
        <input
          type="checkbox"
          checked={termsAccepted}
          onChange={(e) => onTermsChange(e.target.checked)}
        />
        <span>
          He leído y acepto los{" "}
          <button
            type="button"
            className="gm-checkout-terms-link"
            onClick={onOpenTerms}
          >
            Términos y Condiciones
          </button>
          *, y entiendo que, al tratarse de un servicio digital, una vez
          iniciado el test perderé mi derecho de desistimiento.
        </span>
      </label>

      {captchaSlot}

      <ButtonLoading
        type="button"
        className="gm-checkout-confirm-btn"
        disabled={!termsAccepted || loading || disableConfirm}
        loading={loading}
        buttonLabel="Comprar"
        onClick={onConfirm}
      />
    </div>
  );
};

export default InvoiceSummary;
